export const homeDivAnime = {
  from: {
    scale: 0,
  },
  to: {
    scale: 1,
    origin: "center",
    transition: {
      delay: 0.5,
    },
  },
};
